import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { UNIT_FINANCIAL } from './helper'

export const UnitCell = ({ data }) => {
  const { formatedUnit } = useFormatCurrency(SCREEN.SUMMARY)
  return data !== UNIT_FINANCIAL.VND ? data : formatedUnit
}
